<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.order_no"
        placeholder="订单编号"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.title"
        placeholder="标题"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.name"
        placeholder="联系人"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.phone"
        placeholder="电话"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        :clearable="true"
        style="width: 110px"
        class="filter-item"
      >
        <el-option label="套餐" value="1" />
        <el-option label="路线" value="2" />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        :clearable="true"
        style="width: 110px"
        class="filter-item"
      >
        <el-option label="待确认" value="1" />
        <el-option label="预约成功" value="2" />
        <el-option label="预约失败" value="3" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column label="订单编号" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.order_no }}</template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.user.avatar" class="user-avatar" />
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.user.nickname }}</template>
      </el-table-column>
      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.order.name }}</template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.order.phone }}</template>
      </el-table-column>
      <el-table-column label="套餐标题" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.order.product_snap.title }}</template>
      </el-table-column>
      <el-table-column label="预定项目" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.order.product_snap.product_package[0].title}}</template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="入住时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1" type="success">待确认</span>
          <span v-if="scope.row.status == 2" type="danger">预约成功</span>
          <span v-if="scope.row.status == 3" type="danger">预约失败</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.appointment_num }}</template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="预约时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            style="margin:2px 4px"
            size="mini"
            type="success"
            @click="handle(scope.row)"
            v-if="scope.row.status == 1"
          >通过</el-button>
          <el-button
            style="margin:2px 4px"
            size="mini"
            type="danger"
            @click="refuse(scope.row.id)"
            v-if="scope.row.status == 1"
          >驳回</el-button>
          <el-button style="margin:2px 4px" size="mini" type="primary" @click="showInfo(scope.row.order_no)">查看订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 查看订单信息弹框 -->
    <el-dialog :visible.sync="orderVisible" title="订单详情">
      <el-form ref="form" label-width="90px" :model="info">
        <el-form-item label="序号">
          <div>{{ info.id }}</div>
        </el-form-item>
        <el-form-item label="订单编号">
          <div>{{ info.order_no}}</div>
        </el-form-item>
        <el-form-item label="头像">
          <div> <img :src="info.user.avatar" class="user-avatar" /></div>
        </el-form-item>
        <el-form-item label="商家">
          <div>{{ info.order_package?info.order_package[0].shop.name:""}}</div>
        </el-form-item>
        <el-form-item label="姓名">
          <div>{{ info.name }}</div>
        </el-form-item>
        <el-form-item label="联系电话">
          <div>
            {{ info.phone }}
            <!-- <img v-if="info.cover != ''" :src="info.cover" alt style="width: 150px;" /> -->
          </div>
        </el-form-item>
        <el-form-item label="套餐标题">
          <div>{{ info.order_package?info.order_package[0].title:"" }}</div>
        </el-form-item>
        <el-form-item label="数量">
          <div>{{ info.num }}</div>
        </el-form-item>
        <el-form-item label="订单状态">
          <div>
            <span v-if="info.order_status == 0">待付款</span>
            <span v-else-if="info.order_status == 1">进入拼团状态</span>
            <span v-else-if="info.order_status == 2">待使用</span>
            <span v-else-if="info.order_status == 3">进入预约状态</span>
            <span v-else-if="info.order_status == 4">使用中</span>
            <span v-else-if="info.order_status == 5">完成</span>
            <span v-else-if="info.order_status == 6">进入售后状态</span>
            <span v-else-if="info.order_status == 7">已关闭</span>
          </div>
        </el-form-item>
        <el-form-item label="支付时间">
          <div>{{ info.pay_datetime }}</div>
        </el-form-item>
        <el-form-item label="订单总格">
          <div>{{ info.total_price }}</div>
        </el-form-item>
        <el-form-item label="优惠金额">
          <div>{{ info.discount_price }}</div>
        </el-form-item>
        <el-form-item label="实付金额">
          <div>{{ info.pay_price }}</div>
        </el-form-item>
        <el-form-item label="过期时间">
          <div>{{ info.expired }}</div>
        </el-form-item>
        
        <el-form-item label="备注">
          <div>{{ info.remark }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog title="预约通过" :visible.sync="appointmentVisible" width="400px">
      <el-tag>预约张数:{{pass.appointment_num}}</el-tag>
      <!-- <el-tag type="warning" style="margin-left:20px;">需要住几晚:{{pass.live_time}} </el-tag> -->
      <div style="margin:20px 0;">
        <span>入住时间：</span>
        <el-date-picker
        v-model="pass.date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择预约时间"
        :picker-options="pickerOptions"
        @change="dateChange"
      ></el-date-picker>
      </div>
      <!-- <div style="margin:0 0 20px;">
        <span>退房时间：{{pass.endDate}}</span>
      </div> -->
      <div>
        <el-button size="small" @click="appointmentVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="agree">通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import request from "@/utils/request";
import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import * as qiniu from "qiniu-js";
import AMapPosition from "@/components/AMapPosition";
var moment = require('moment')
export default {
  components: {
    "img-crop-upload": imgCropUpload,
    "amap-position": AMapPosition,
    uploadList
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      info: {order_package:[{shop:{}}],user:{}},
      listQuery: {
        page: 1,
        limit: 10,
        order_no: "",
        title: "",
        name: "",
        phone: "",
        type: "",
        status: ""
      },
      pass:{
        id:null,
        date:null,
        live_time:'',
        appointment_num:'',
        expired:'',
        endDate:'',
      },
      canLiveDay:-1,
      appointmentVisible:false,
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      dialogPvVisible: false,
      dialogPvVisible1: false,
      orderVisible: false,
      pvData: [],
      form: {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      },
      rules: {
        img: [{ required: true, message: "图片不能为空", trigger: "blur" }]
      },
      btnLoading: false,
      show: false,
      imgBase64Data: "", // the datebase64 url of created image
    };
  },
  created() {
    this.getList();
  },
  computed: {
    pickerOptions() {
      let _this = this
      let expired = moment(_this.pass.expired).format('x')
      let today = moment().subtract(1, 'days').format('x')
      return {
        disabledDate(time) {
          return time.getTime() > expired || time.getTime() < today
        }
      }
    }
  },   
  watch: {
    'pass.date'(newVal) {
      this.pass.endDate = moment(newVal).add(this.pass.live_time, 'days').format('YYYY-MM-DD')
    }
  },
  methods: {
    dateChange(e) {
      // this.pass.endDate = moment(this.pass.date).add(this.pass.live_time, 'days').format('YYYY-MM-DD')
      // console.log(this.pass.date)
      // console.log(this.pass.live_time)
      // console.log(this.pass.endDate)
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/order/appointment",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handle(row) {
      let {date,id,appointment_num} = row
      this.pass = {date,id,appointment_num}
      this.pass.expired = row.order.product_snap.expired
      this.pass.live_time = row.order.product_snap.product_package[0].live_time
      this.pass.endDate = moment(this.pass.date).add(this.pass.live_time, 'days').format('YYYY-MM-DD')
      // let restTime = moment(this.pass.expired).subtract(this.pass.live_time, 'days').format('YYYY-MM-DD')
      // if(moment(restTime).isBefore(this.pass.date)) {
      //   let timeStr = moment(this.pass.date).format('x') - moment(restTime).format('x')
      //   let day = timeStr / 24 / 60 / 60 /1000
      //   this.canLiveDay = this.pass.live_time - day
      // }else {
      //   this.canLiveDay = -1
      // }
      this.appointmentVisible = true;
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    agree() {
      let pass = {
        id: this.pass.id,
        date: this.pass.date
      }
      request({
        url: "/api/backend/order/agree",
        method: "post",
        data: pass
      }).then(response => {
         this.$notify({
          title: "成功",
          message: "通过成功",
          type: "success",
          duration: 2000
        });
        this.appointmentVisible = false;
        this.getList();
      });
    },
    refuse(id) {
      this.$confirm("确定要驳回, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
           request({
        url: "/api/backend/order/refuse",
        method: "post",
        data: { id: id }
      }).then(response => {
        this.$notify({
          title: "成功",
          message: "驳回成功",
          type: "success",
          duration: 2000
        });
        this.getList();
      });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
     
    },
    resetForm() {
      this.form = {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      };
      this.btnLoading = false;
    },

    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    showInfo(order_no) {

      request({
        url: "/api/backend/order/detail",
        method: "get",
        params: { order_no: order_no }
      }).then(response => {
        this.info = response.data;
        this.orderVisible = true;
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handledown(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible1 = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      console.log(this.form, this.form.imgArray);
      return;
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/banner/save",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/banner/del",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgBase64Data, field) {
      console.log("-------- 裁剪成功 --------");
      let that = this;
      this.imgBase64Data = imgBase64Data;
      getQiniuToken().then(response => {
        let file = base64toFile(imgBase64Data, "tmp.png");
        let key = guid() + ".png";
        let token = response.data.token;
        let baseUrl = response.data.baseUrl;
        let putExtra = {};
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2
        };
        var observable = qiniu.upload(file, key, token, putExtra, config);
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + "/" + key;
            that.form.img = imgUrl;
            console.log(imgUrl);
          }
        }); // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      });
    }
  }
};
</script>


<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
